module.exports = __webpack_public_path__ + "../web/img/trailer-slider.5432e5de.svg";